import React, { useContext } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import './RelatedArticel.css';
import ViewMoreButtonDesktop, { ViewMoreButtonMobile } from "../WebButton/ViewMoreButton";
import { useAppContext } from "../Context/AppContext";

const RealtedArticel = (props) => {
    const { children = [], title = "Related Articles", url } = props;
    const { BASE_PATH } = useContext(useAppContext);

    if (!children || children.length === 0) return null;

    // ✅ HANDLE BOTH API STRUCTURES
    const getArticleUrl = (item) => {
        return item?.articleurl || item?.post_url || "";
    };

    const getImage = (item) => {
        return item?.imagepath || item?.image || "";
    };

    const getCategory = (item) => {
        return item?.categoryname || item?.categorytitle || "News";
    };

    return (
        <section className="relatedarticel">
            <Container>

                <Row>
                    <div className='whitetitle'>
                        <h1>{title}</h1>
                        <ViewMoreButtonDesktop redirect={url || children[0]?.categoryurl || "film-gossip"} />
                    </div>
                </Row>

                <Row>
                    {/* LEFT BIG CARD */}
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <Card>
                            <Card.Img
                                variant="top"
                                src={getImage(children[0])}
                                alt={title}
                                loading="lazy"
                            />
                            <Card.Body>
                                <Card.Text className='card-category'>
                                    {getCategory(children[0])}
                                </Card.Text>

                                <Card.Link href={`${BASE_PATH}${children[0]?.categoryurl}/${getArticleUrl(children[0])}`}>
                                    <Card.Title className="word-line-limit3 first-artical-title">
                                        {children[0]?.title}
                                    </Card.Title>
                                </Card.Link>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* RIGHT SIDE */}
                    <Col lg={6} md={12} sm={12} xs={12}>

                        {/* ROW 1 */}
                        <Row>
                            {[1, 2].map(i => (
                                <Col key={i} lg={6} md={6} sm={6} xs={6}>
                                    {children[i] && (
                                        <Card>
                                            <Card.Img
                                                variant="top"
                                                src={getImage(children[i])}
                                                alt={title}
                                                loading="lazy"
                                            />
                                            <Card.Body>
                                                <Card.Text className='card-category'>
                                                    {getCategory(children[i])}
                                                </Card.Text>

                                                <Card.Link href={`${BASE_PATH}${children[i]?.categoryurl}/${getArticleUrl(children[i])}`}>
                                                    <Card.Title className='word-line-limit'>
                                                        {children[i]?.title}
                                                    </Card.Title>
                                                </Card.Link>
                                            </Card.Body>
                                        </Card>
                                    )}
                                </Col>
                            ))}
                        </Row>

                        {/* ROW 2 */}
                        <Row>
                            {[3, 4].map(i => (
                                <Col key={i} lg={6} md={6} sm={6} xs={6}>
                                    {children[i] && (
                                        <Card>
                                            <Card.Img
                                                variant="top"
                                                src={getImage(children[i])}
                                                alt={title}
                                                loading="lazy"
                                            />
                                            <Card.Body>
                                                <Card.Text className='card-category'>
                                                    {getCategory(children[i])}
                                                </Card.Text>

                                                <Card.Link href={`${BASE_PATH}${children[i]?.categoryurl}/${getArticleUrl(children[i])}`}>
                                                    <Card.Title className='word-line-limit'>
                                                        {children[i]?.title}
                                                    </Card.Title>
                                                </Card.Link>
                                            </Card.Body>
                                        </Card>
                                    )}
                                </Col>
                            ))}
                        </Row>

                    </Col>
                </Row>

                <ViewMoreButtonMobile redirect={url || children[0]?.categoryurl || "film-gossip"} />

            </Container>
        </section>
    );
};

export default RealtedArticel;